import update from 'immutability-helper'
import { ADD_COMPONENT } from '../constants'

export default function (state = {}, action: any) {
  switch (action.type) {
    case ADD_COMPONENT:
      return update(state, {
        $apply: function (components) {
          if (action.component) {
            components[action.key || action.component.displayName || action.component.name] =
              action.component
          }
          return components
        },
      })
    default:
      return state
  }
}
